import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreatePruebaTestimonialRequest  extends CreateKeyValueRequest{

  idUsuarioResponsable!: number | null;
  idPersonaTestigo!: number | null;
  idTipoInterviniente!: number | null;
  idEstadoPrueba!: number | null;
  fechaDeclaraion!: string | null;
  autoridadDeclaracion!: string | null;
  declaracion!: string | null;
  medioRegistro!: string | null;
  grupo!: number | null;
  fechaPrimeraAudiencia!: string | null;
  fechaCedulaPresentacionPrimeraAudiencia!: string | null;
  fechaCedulaNotificacionPrimeraAudiencia!: string | null;
  fechaSegundaAudiencia!: string | null;
  fechaCedulaPresentacionSegundaAudiencia!: string | null;
  fechaCedulaNotificacionSegundaAudiencia!: string | null;
  idExpediente!: number | null;
}
